// extracted by mini-css-extract-plugin
export default {"input":"styles__input___tXt13"};